"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalContextProvider = exports.GlobalContext = void 0;
const react_1 = __importStar(require("react"));
const store_1 = require("../store");
const react_redux_1 = require("react-redux");
const ahooks_1 = require("ahooks");
const core_1 = require("../core");
const _Provider = react_redux_1.Provider;
exports.GlobalContext = react_1.default.createContext(null);
/**
 * Used at the topmost level in a standalone widget environment, equivalent to a complete datasheet runtime environment.
 * There can be only one globalContextProvider globally,
 * which can provide dependency support to multiple widgetStandAloneProvider.
 * When using the GlobalContextProvider,
 * just make sure that the globalContextProvider exists in the parent component above the widgetStandAloneProvider.
 */
const GlobalContextProvider = ({ children }) => {
    const [globalContext] = (0, react_1.useState)(() => {
        const gtx = (0, store_1.initGlobalContext)();
        (0, core_1.injectStore)(gtx.globalStore);
        gtx.resourceService.init();
        return gtx;
    });
    (0, ahooks_1.useUnmount)(() => {
        globalContext.unSubscribe && globalContext.unSubscribe();
        globalContext.resourceService.destroy();
    });
    return (react_1.default.createElement(_Provider, { store: globalContext.globalStore },
        react_1.default.createElement(exports.GlobalContext.Provider, { value: globalContext }, children)));
};
exports.GlobalContextProvider = GlobalContextProvider;
